import React, { useState, useEffect } from "react";

const API_URL = "https://api.ust.is/aq/a/getLatest";

export const AqDataTable = () => {
  const [data, setData] = useState([]);
  const [expandedRows, setExpandedRows] = useState({});

  useEffect(() => {
    fetch(API_URL)
      .then((response) => { console.log(">>> response", response); return response.json() })
      .then((data) => { console.log(">>> data", data); setData(data || []) })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  const toggleRow = (id) => {
    setExpandedRows((prev) => ({
      ...prev,
      [id]: !prev[id], // Toggle the row expansion
    }));
  };

  console.log(">>> state.data", data);

  return (
    <div>
      <h2>Air Quality Data</h2>
      <table border="1" cellPadding="10">
        <thead>
          <tr>
            <th>Station</th>
            <th>Measurement</th>
            <th>Value</th>
            <th>Unit</th>
          </tr>
        </thead>
        <tbody>
          {Object.values(data).map((station, index) => (
            <tr onClick={() => toggleRow(`${index}-${index}`)} style={{ cursor: "pointer" }}>
              <td>{station.name || "N/A"}</td>
            {Object.entries(station.parameters).map(([param, readings], paramIndex) => {
              // Extract the latest reading
              const latestReading = readings['0']; 
              return (
                <React.Fragment key={`${index}-${paramIndex}`}>
                  {/* Main Row */}
                  
                    
                    <td>
                      <strong>{param}</strong>
                      <br/>
                      {latestReading?.value !== undefined ? latestReading.value : "N/A"} {readings.unit || "N/A"}
                      {/* <br /> */}
                      {/* {latestReading?.endtime ? new Date(latestReading.endtime).toLocaleString('no-NO') : "N/A"} */}
                    </td>
                  

                  {/* Expanded Row for Older Data */}
                  {expandedRows[`${index}-${paramIndex}`] && (
                    <tr>
                      <td colSpan="5">
                        <strong>Older Data:</strong>
                        <table border="1" width="100%">
                          <thead>
                            <tr>
                              <th>Timestamp</th>
                              <th>Value</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Object.entries(readings)
                              .filter(([key]) => key !== "unit" && key !== "resolution") // Exclude metadata fields
                              .map(([key, oldReading]) => (
                                <tr key={key}>
                                  <td>{new Date(oldReading.endtime).toLocaleString()}</td>
                                  <td>{oldReading.value}</td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
